export const CURRENCYLIST = [
  {
    value: 'EUR',
    shorthand: '€',
  },
  {
    value: 'USD',
    shorthand: '$',
  },
  {
    value: 'CHF',
    shorthand: 'CHF',
  },
  {
    value: 'GBP',
    shorthand: '£',
  },
  {
    value: 'AUD',
    shorthand: '$',
  },
  {
    value: 'NZD',
    shorthand: '$',
  },
  {
    value: 'IDR',
    shorthand: 'Rp',
  },
  {
    value: 'INR',
    shorthand: '₹',
  },
  {
    value: 'MYR',
    shorthand: 'RM',
  },
  {
    value: 'THB',
    shorthand: '฿',
  },
  {
    value: 'CNY',
    shorthand: '¥',
  },
  {
    value: 'SEK',
    shorthand: 'Kr',
  },
  {
    value: 'JPY',
    shorthand: '¥',
  },
  {
    value: 'CAD',
    shorthand: 'CAD',
  },
];
